module.exports = __webpack_public_path__ + "static/media/walrus.eca66536.svg";